import { render, staticRenderFns } from "./BannerPrincipal.vue?vue&type=template&id=4004fdb2&lang=pug&"
import script from "./BannerPrincipal.vue?vue&type=script&lang=js&"
export * from "./BannerPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./BannerPrincipal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports